import ls from 'local-storage'

const SUBROUTES = Array.isArray(process.env.SUBROUTES) ? process.env.SUBROUTES : []

export const getFiltersByLocalStorageKey = (lsKey) => {
  const cachedFilters = ls.get(lsKey)
  const filterType = lsKey == 'MY_WORK_QUEUE_FILTERS' ? 'myWorkQueueFilters' : 'myRecordsFilters'
  let filtersByCategory = SUBROUTES.reduce(
    (obj, sub) => ({
      ...obj,
      [sub.parameter]: sub[filterType]
        ? sub[filterType].reduce((fObj, f) => ({ ...fObj, [f.name]: f.defaultValue || '' }), {
            SEARCH: '',
          })
        : {},
    }),
    {}
  )
  if (cachedFilters) {
    filtersByCategory = Object.keys(filtersByCategory).reduce((obj, category) => {
      return {
        ...obj,
        [category]: Object.keys(filtersByCategory[category]).reduce((fObj, key) => {
          return {
            ...fObj,
            [key]: cachedFilters[category]
              ? cachedFilters[category][key] !== undefined
                ? cachedFilters[category][key]
                : filtersByCategory[category][key]
              : filtersByCategory[category][key],
          }
        }, {}),
      }
    }, {})
  }
  return filtersByCategory
}



// WEBPACK FOOTER //
// ./src/Utilities/FilterUtilities.js